import type { RundownCueOrderItem } from '@rundown-studio/types'
import { useAtomValue } from 'jotai'
import { getTimestampByCueIdAtom } from '../../../store/timestamps.store.ts'
import type { Timestamp } from '@rundown-studio/utils'

export const useGroupTimestamps = (
  groupCues: RundownCueOrderItem[],
): Timestamp[] => {
  const getTimestampByCueId = useAtomValue(getTimestampByCueIdAtom)

  return groupCues
    ?.map((cue) => getTimestampByCueId(cue.id))
    .filter(Boolean) as Timestamp[]
}
